module.exports = __webpack_public_path__ + "assets/images/home_y.a96cf39b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/home_y.png
// module id = 737
// module chunks = 1